import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'fi';
    document.title = 'YMPÄRISTÖOPPI VALMIS™ – Valmiit ympäristöopin tunnit 1.–6. luokille';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mjztd6hzp62c">
      <div lang="fi" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3rc9i4j7dc031">
        <CountdownBar data-id="element-2" data-mp="5yjsutqtdfe" />
        <main data-id="element-3" data-mp="6hq1ea16ddl">
          <Hero data-id="element-4" data-mp="4wupmfw6qeo" />
          <StatsBar data-id="element-5" data-mp="5gfrc0u9uwx" />
          <Difference data-id="element-6" data-mp="82jt1oitsae" />
          <Recognize data-id="element-7" data-mp="2zld1d7i6tbah" />
          <WhatsInside data-id="element-8" data-mp="2zlv84y2h77wn" />
          <InsidePages data-id="element-9" data-mp="2zmo4r67q0h12" />
          <Bonuses data-id="element-10" data-mp="2zn6cayzu2hoa" />
          <HowItWorks data-id="element-11" data-mp="33morde4z3yj7" />
          <Audience data-id="element-12" data-mp="33lwywc6oagx5" />
          <Offer data-id="element-13" data-mp="33ngfk3w8qtzg" />
          <Guarantee data-id="element-14" data-mp="33myl9ct52pu6" />
          <Testimonials data-id="element-15" data-mp="38lromcepp0gm" />
          <Faq data-id="element-16" data-mp="38l8hlqqlnwhd" />
          <FinalCta data-id="element-17" data-mp="38kqbm2e4y3w9" />
        </main>
        <Footer data-id="element-18" data-mp="38nunzn1r85y0" />
      </div>
    </MotionConfig>;
}